import { PageLinkComponentProps } from "@omni/ui/components/PageLink/pageLink.props";
import { isDefined } from "@omni/utils/helper.utils";
import { createContext, ReactNode, use } from "react";

import { HeaderButtonBaseProps } from "@/components/Navigation/Buttons/HeaderButton/headerButton.base";

type AccountButtonContextValue = {
    isLoggedIn: boolean;
    headerButtonProps: HeaderButtonBaseProps;
    links?: PageLinkComponentProps[];
};

type AccountButtonContextProviderProps = {
    isLoggedIn: boolean;
    headerButtonProps: HeaderButtonBaseProps;
    links?: PageLinkComponentProps[];
    children: ReactNode;
};

export const AccountButtonContext = createContext<
    AccountButtonContextValue | undefined
>(undefined);

export const AccountButtonContextProvider = ({
    isLoggedIn,
    headerButtonProps,
    links,
    children
}: AccountButtonContextProviderProps) => {
    return (
        <AccountButtonContext.Provider
            value={{
                isLoggedIn: isLoggedIn,
                headerButtonProps: headerButtonProps,
                links: links
            }}
        >
            {children}
        </AccountButtonContext.Provider>
    );
};

export const useAccountButtonContext = () => {
    const context = use<AccountButtonContextValue | undefined>(
        AccountButtonContext
    );

    if (!isDefined(context)) {
        throw new Error(`${AccountButtonContext.displayName} is undefined.`);
    }

    return context;
};
